// Configuration du module système ApiStatusBanner
import type { ComponentMetadata } from '../../G&CSCM/Core/types';

export const ApiStatusBannerConfig: ComponentMetadata = {
    name: 'ApiStatusBanner',
    displayName: 'Bannière État API',
    description: 'Affiche une bannière quand l\'API est hors ligne (module système requis)',
    category: 'System',
    defaultParams: {},
    paramDefinitions: {},
    outsideGrid: true, // Toujours en dehors de la grille
    defaultEnabled: true
};

export default ApiStatusBannerConfig;


